import React, { useState } from 'react';
import CarRegistrationForm from '../CarRegistrationForm/CarRegistrationForm';
import DelictIdForm from '../DelictIdForm/DelictIdForm';
import ReferenceForm from '../ReferenceForm/ReferenceForm';
import withDataCheck, { withDataCheckProps } from '../../hoc/withDataCheck/withDataCheck';
import { Row, Container, Col } from 'react-bootstrap';
import CheckResult from '../CheckResult/CheckResult';
import { NavLink, Route, Switch, Redirect } from 'react-router-dom';
import './ViolationCheck.scss';
//import PersonalDataForm from '../PersonalDataForm/PersonalDataForm';

import { useTranslation } from 'react-i18next';

/**
 * Component/Page to check for violations
 *
 * @component - ViolationCheck
 * @parentComponent - App
 */

interface Props extends withDataCheckProps {}

const ViolationCheck = (props: Props) => {
  const [isDirty, changeDirtyState] = useState(true);

  const { t } = useTranslation();

  function clearDirtyState() {
    changeDirtyState(false);
  }

  function setDirtyState() {
    changeDirtyState(true);
  }

  function handleLinksClick(e: any): void {
    // Check if current link match windows.loacation.url and call e.preventDefault
    const location = window.location.href.split('/').pop();
    const href = e.target.getAttribute('href').split('/').pop();
    location === href ? e.preventDefault() : setDirtyState();
  }

  return (
    <div className="ViolationCheck">
      <Container>
        <Row>
          <Col>
            <h5 className="heading">{t('ViolationCheck.heading')}</h5>
            <div className="navLinks">
              <NavLink exact to={'/violation'} onClick={handleLinksClick} activeClassName="activeLink">
                {t('ViolationCheck.delictIdForm.link')}
              </NavLink>
              <NavLink exact to={'/violation/plate'} onClick={handleLinksClick} activeClassName="activeLink">
                {t('ViolationCheck.carRegistrationForm.link')}
              </NavLink>
              {/* <NavLink exact to={'/violation/id'} onClick={handleLinksClick} activeClassName="activeLink">
              {t('ViolationCheck.personalDataForm.link')}
            </NavLink> */}
             <NavLink exact to={'/violation/delict'} onClick={handleLinksClick} activeClassName="activeLink">
                {t('ViolationCheck.referenceForm.link')}
              </NavLink>
            </div>
          </Col>
        </Row>
      </Container>
      <Switch>
        <Route
          exact
          path="/violation"
          render={() => (
            <DelictIdForm
              dataCheck={props.configureDataCheck('check/violation/v2')}
              clearDirtyState={clearDirtyState}
              setDirtyState={setDirtyState}
            />
          )}
        />
        <Route
          exact
          path="/violation/plate"
          render={() => (
            <CarRegistrationForm
              dataCheck={props.configureDataCheck('check/violation/v2')}
              clearDirtyState={clearDirtyState}
              setDirtyState={setDirtyState}
              setPersonalNumberInput={true}
            />
          )}
        />
        <Route
          exact
          path="/violation/v2/plate"
          render={() => (
            <CarRegistrationForm
              dataCheck={props.configureDataCheck('check/violation/v2')}
              clearDirtyState={clearDirtyState}
              setDirtyState={setDirtyState}
              setPersonalNumberInput={true}
            />
          )}
        />
        <Route
          exact
          path="/violation/delict"
          render={() => (
            <ReferenceForm
              dataCheck={props.configureDataCheck('check/violation/delict')}
              clearDirtyState={clearDirtyState}
              setDirtyState={setDirtyState}
              setReferenceNo={true}
            />
          )}
        />
        {/* <Route exact path='/violation/id' render={()=> (
          <PersonalDataForm dataCheck={props.configureDataCheck('check/violation')} clearDirtyState={clearDirtyState} setDirtyState={setDirtyState}/>
      )} /> */}
        <Route render={() => <Redirect to="/violation" />} />
      </Switch>
      <CheckResult data={props} type={'violation'} isDirty={isDirty} />
    </div>
  );
};

export default withDataCheck(ViolationCheck);
